import { render, staticRenderFns } from "./jdyzfz.vue?vue&type=template&id=7dc4f3c4&scoped=true&"
import script from "./jdyzfz.vue?vue&type=script&lang=js&"
export * from "./jdyzfz.vue?vue&type=script&lang=js&"
import style0 from "./jdyzfz.vue?vue&type=style&index=0&id=7dc4f3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc4f3c4",
  null
  
)

export default component.exports